// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getIsProductPriceLoading = (state: ApplicationState, productId: string) => {
    return Boolean(state.store.data.products.realTimePriceLoading[productId]);
};
